import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--left",
  "use": "icon-arrow--left-usage",
  "viewBox": "0 0 5 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 5 7\" id=\"icon-arrow--left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.207.293 4.62 1.707 2.828 3.5l1.793 1.793-1.414 1.414L0 3.5 3.207.293Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol